import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function SavingsInvestmentsPage() {
  useEffect(() => {
    const hamburger = document.querySelector('.hamburger');
    const sidebar = document.getElementById('sidebar');
    const closeSidebar = document.querySelector('.close-sidebar');
    if (hamburger && sidebar && closeSidebar) {
      hamburger.onclick = () => sidebar.classList.add('active');
      closeSidebar.onclick = () => sidebar.classList.remove('active');
    }
    return () => {
      if (hamburger) hamburger.onclick = null;
      if (closeSidebar) closeSidebar.onclick = null;
    };
  }, []);

  return (
    <main className="savings-investments-page">
      <nav className="regular-navbar">
        <Link className="logo" to="/">
          <img src="/logo.jpg" alt="company logo" />
        </Link>
        <div className="hamburger">
          <img src="/static/media/hamburger-black.c116047ebd06e70caac47be95fd90698.svg" alt="menu" />
        </div>
        <div className="links">
          <div className="void"></div>
          <div className="cont">
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About us</Link></li>
              <li><Link to="/loans">Loans</Link></li>
              <li><Link to="/savings-investments">Savings & Investment</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
            <div className="btns">
              <button className="transparent"><Link to="/register">Register</Link></button>
              <button className="blue"><Link to="/login">Sign In</Link></button>
            </div>
          </div>
        </div>
      </nav>
      <div id="sidebar">
        <ul>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div></div>
            <div className="close-sidebar">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-circle" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
              </svg>
            </div>
          </div>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/about">About us</Link></li>
          <li><Link to="/loans">Loans</Link></li>
          <li><Link to="/savings-investments">Savings & Investment</Link></li>
          <li><Link to="/contact">Contact Us</Link></li>
          <div className="btnss" style={{ marginTop: 14 }}>
            <button className="transparent" style={{ marginRight: 5 }}><Link to="/register">Register</Link></button>
            <button className="blue"><Link to="/login">Sign In</Link></button>
          </div>
        </ul>
      </div>
      <header className="page-header">
        <div className="text-info">
          <h1>Savings &amp; Investment</h1>
          <p>With our range of savings and investment options, we offer a variety of ways for you to grow your wealth and achieve your financial goals. Our savings accounts offer competitive interest rates, no fees, and easy access to your money whenever you need it. And with our investment options, you can invest in a range of assets, with the guidance of our expert advisors.</p>
          <button className="white"><Link to="/register">Open a savings account</Link></button>
        </div>
        <div className="img"><img src="/static/media/savings-investments-header.083378a9b3944e88b8ce.webp" alt="Savings & Investment" /></div>
      </header>
      <section className="grow-savings">
        <h2 className="title">Secure and Grow Your Savings</h2>
        <p className="sub-title">We understand the importance of saving money and building a solid financial foundation, which is why we offer a variety of savings account options to help you reach your financial goals. Whether you're saving for a down payment on a house, a dream vacation, or simply a rainy day, we've got you covered. Our savings accounts offer competitive interest rates and flexible terms, so you can choose the account that best suits your needs.</p>
        <div className="cards">
          <div className="card">
            <div className="img"><img src="/static/media/basic-savings-account.2c90140897f2871ea3f7.webp" alt="basic savings account" /></div>
            <div className="text"><h4>Basic Savings Account</h4></div>
          </div>
          <div className="card">
            <div className="img"><img src="/static/media/high-yield-savings-account.797d4628c7cfea1fdff5.webp" alt="high yield savings account" /></div>
            <div className="text"><h4>High-Yield Savings Account</h4></div>
          </div>
          <div className="card">
            <div className="img"><img src="/static/media/money-market-account.4bcaf61ce214cc52c166.webp" alt="money market account" /></div>
            <div className="text"><h4>Money Market Account</h4></div>
          </div>
          <div className="card">
            <div className="img"><img src="/static/media/ira.609bdbe698c2a7e9dc81.webp" alt="individual retirement account" /></div>
            <div className="text"><h4>Individual Retirement Account (IRA)</h4></div>
          </div>
          <div className="card">
            <div className="img"><img src="/static/media/kids-savings-account.86f9b893ccd56fd5465e.webp" alt="kids savings account" /></div>
            <div className="text"><h4>Kids' Savings Account</h4></div>
          </div>
          <div className="card">
            <div className="img"><img src="/static/media/cerficate-of-deposit.12bd0bf5afef57b58530.webp" alt="certificate of deposit" /></div>
            <div className="text"><h4>Certificate of Deposit (CD)</h4></div>
          </div>
        </div>
      </section>
      <section className="top-tier-investments">
        <h2 className="title">Top Tier Investments Available To You</h2>
        <p className="sub-title">Investing your money can be a powerful way to grow your wealth and achieve your financial goals. Whether you're saving for retirement, a child's education, or simply looking to build your portfolio, we offer a range of investment options to help you achieve your goals. Our investment products are designed to help you build a diversified portfolio tailored to your risk tolerance and investment objectives. With our expert guidance and resources, you can make informed investment decisions and build a stronger financial future.</p>
        <div className="cards">
          <div className="card">
            <div className="img"><img src="/static/media/mutual-funds.445df7b1283276ea3a80.webp" alt="mutual funds" /></div>
            <div className="text">
              <h3>Mutual Funds</h3>
              <p>Professionally managed portfolios of stocks, bonds, and other securities that offer diversification and potential for growth. We offer a wide range of mutual funds to suit your investment goals and risk tolerance.</p>
              <button className="blue"><Link to="/login">Sign in</Link></button>
            </div>
          </div>
          <div className="card">
            <div className="img"><img src="/static/media/stocks.947e6217edfc9cfe880c.webp" alt="stocks" /></div>
            <div className="text">
              <h3>Stocks</h3>
              <p>Stocks represent ownership in a company and offer the potential for long-term growth. We offer a range of stocks from established companies with a track record of success to emerging companies with high growth potential.</p>
              <button className="blue"><Link to="/login">Sign in</Link></button>
            </div>
          </div>
          <div className="card">
            <div className="img"><img src="/static/media/bonds.a28e7d62573f25305250.webp" alt="bonds" /></div>
            <div className="text">
              <h3>Bonds</h3>
              <p>Bonds are debt securities issued by governments or companies and offer a fixed rate of return. We offer a range of bonds with varying maturities and credit ratings to suit your investment objectives.</p>
              <button className="blue"><Link to="/login">Sign in</Link></button>
            </div>
          </div>
          <div className="card">
            <div className="img"><img src="/static/media/real-estate-investment-trusts.04b04aab4203f2a029f5.webp" alt="real estate investment trusts" /></div>
            <div className="text">
              <h3>Real Estate Investment Trusts (REITs)</h3>
              <p>REITs are companies that own and operate income-producing real estate properties. Investing in REITs can provide exposure to the real estate market without the hassle of property management.</p>
              <button className="blue"><Link to="/login">Sign in</Link></button>
            </div>
          </div>
        </div>
      </section>
      <article className="financial-freedom">
        <div className="text">
          <h2>Take a Step Towards Financial Freedom</h2>
          <p>Ready to start achieving your financial goals? Open an account today and discover the benefits of banking with us all from the comfort of your home.</p>
          <button className="white"><Link to="/register">Open an account today</Link></button>
        </div>
        <div className="img"><img src="/static/media/financial-freedom.81826f816f2e9f3fe1c9.png" alt="Financial Freedom" /></div>
      </article>
      <footer className="footer">
        <div className="grid">
          <div className="item logo-info">
            <div className="logo"></div>
            <p>At Safenet Banking, your financial security is our top priority. We are committed to providing you with a seamless and secure online banking experience.</p>
          </div>
          <div className="item list">
            <h3>Company</h3>
            <ul>
              <li><Link to="/about">About us</Link></li>
              <li><Link to="/terms-&-conditions">Terms & conditions</Link></li>
              <li><Link to="/privacy-policies">Privacy policies</Link></li>
            </ul>
          </div>
          <div className="item list">
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/security">Security</Link></li>
            </ul>
          </div>
          <div className="item list">
            <h3>Customer Support</h3>
            <ul>
              <li><Link to="/contact">Get help</Link></li>
              <li><Link to="/frequently-asked-questions">FAQs</Link></li>
              <li><a href="mailto:info@safenetbanking.com">Email us</a></li>
            </ul>
          </div>
          <div className="item socials">
            <h3>Follow us</h3>
            <ul>
              <li><a href="#"><i className="fa fa-facebook"></i></a></li>
              <li><a href="#"><i className="fa fa-twitter"></i></a></li>
              <li><a href="#"><i className="fa fa-linkedin"></i></a></li>
            </ul>
          </div>
        </div>
        <div className="copyright">
          <p>Copyright 2022 Safenet Banking. Licensed by the Central Bank of United States.</p>
        </div>
      </footer>
    </main>
  );
}
